
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Spedizione } from '@/models';
import ItemListSpedizione from "./ItemListSpedizione.vue";

@Component({
    components: { ItemListSpedizione }
})
export default class SpedizioniList extends Vue {
    @Prop() private spedizioni!: Spedizione[];    
}
